(function () {
  function setCheckoutEnabled(enabled, checkoutBtn, dynamicWrap) {
    checkoutBtn.disabled = !enabled;
    checkoutBtn.setAttribute('aria-disabled', String(!enabled));
    if (dynamicWrap) {
      if (enabled) {
        dynamicWrap.classList.remove('rta-gate-disabled');
        dynamicWrap.removeAttribute('aria-disabled');
      } else {
        dynamicWrap.classList.add('rta-gate-disabled');
        dynamicWrap.setAttribute('aria-disabled', 'true');
      }
    }
  }

  function initReturnsGate(root) {
    root = root || document;

    var agreeCheckbox = root.querySelector('#rta-returns-agree');
    var checkoutBtn = root.querySelector('#checkout');
    var dynamicWrap = root.querySelector('.cart__dynamic-checkout-buttons');
    var modal = root.querySelector('#rta-contact-modal');
    var modalCheckbox = root.querySelector('#rta-contact-checkbox');
    var continueBtn = root.querySelector('#rta-contact-continue');
    var cancelBtn = root.querySelector('#rta-contact-cancel');
    var overlay = modal ? modal.querySelector('.rta-contact-modal__overlay') : null;

    if (!agreeCheckbox || !checkoutBtn) {
      return;
    }

    function refresh() {
      var confirmed = agreeCheckbox.dataset.contactConfirmed === 'true';
      setCheckoutEnabled(agreeCheckbox.checked && confirmed, checkoutBtn, dynamicWrap);
    }

    function openModal() {
      if (!modal) {
        // No modal markup present for some reason — don't block checkout on a
        // confirmation step that can't be shown.
        agreeCheckbox.dataset.contactConfirmed = 'true';
        refresh();
        return;
      }
      if (modalCheckbox) {
        modalCheckbox.checked = false;
      }
      if (continueBtn) {
        continueBtn.disabled = true;
      }
      modal.hidden = false;
    }

    function closeModal() {
      if (modal) {
        modal.hidden = true;
      }
    }

    refresh();

    if (agreeCheckbox.dataset.rtaBound !== 'true') {
      agreeCheckbox.dataset.rtaBound = 'true';
      agreeCheckbox.addEventListener('change', function () {
        if (agreeCheckbox.checked) {
          if (agreeCheckbox.dataset.contactConfirmed !== 'true') {
            openModal();
          }
        } else {
          agreeCheckbox.dataset.contactConfirmed = 'false';
          closeModal();
        }
        refresh();
      });
    }

    if (modalCheckbox && modalCheckbox.dataset.rtaBound !== 'true') {
      modalCheckbox.dataset.rtaBound = 'true';
      modalCheckbox.addEventListener('change', function () {
        if (continueBtn) {
          continueBtn.disabled = !modalCheckbox.checked;
        }
      });
    }

    if (continueBtn && continueBtn.dataset.rtaBound !== 'true') {
      continueBtn.dataset.rtaBound = 'true';
      continueBtn.addEventListener('click', function () {
        if (!modalCheckbox || !modalCheckbox.checked) {
          return;
        }
        agreeCheckbox.dataset.contactConfirmed = 'true';
        closeModal();
        refresh();

        // "Continue to checkout" should actually take them to checkout, rather
        // than just unlocking the checkout button and leaving them to find and
        // click it again. Only the standard checkout button is triggered here —
        // Shop Pay/PayPal-style express buttons are third-party embeds that
        // aren't safe to click programmatically, so those stay available for
        // the customer to click themselves once unlocked.
        if (checkoutBtn && !checkoutBtn.disabled) {
          checkoutBtn.click();
        }
      });
    }

    if (cancelBtn && cancelBtn.dataset.rtaBound !== 'true') {
      cancelBtn.dataset.rtaBound = 'true';
      cancelBtn.addEventListener('click', function () {
        agreeCheckbox.checked = false;
        agreeCheckbox.dataset.contactConfirmed = 'false';
        closeModal();
        refresh();
      });
    }

    if (overlay && overlay.dataset.rtaBound !== 'true') {
      overlay.dataset.rtaBound = 'true';
      overlay.addEventListener('click', function () {
        agreeCheckbox.checked = false;
        agreeCheckbox.dataset.contactConfirmed = 'false';
        closeModal();
        refresh();
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReturnsGate(document);
  });

  // The cart section (checkbox, modal, checkout button, dynamic checkout buttons)
  // can be re-rendered wholesale after an AJAX cart update (e.g. changing a
  // quantity). Watching the page for that keeps the gate correctly wired to
  // whichever elements are currently in the DOM, and correctly resets the
  // agreement/confirmation back to unchecked whenever the cart contents change.
  if (window.MutationObserver) {
    var observer = new MutationObserver(function () {
      initReturnsGate(document);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      initReturnsGate(document);
    });
  }
})();
